import { render } from "./index.vue?vue&type=template&id=c8a70580&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=c8a70580&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8a70580"],['__file',"src/components/SvgIcon/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c8a70580"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c8a70580', __exports__)) {
    api.reload('c8a70580', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=c8a70580&scoped=true", () => {
    api.rerender('c8a70580', render)
  })

}


export default __exports__